import React, { useMemo } from "react";
import { TextInput } from "react-native";

import { TextInputControlProps } from "./TextInputControl.types";
import { FormInput } from "../../../common";

export const InputControl = React.forwardRef(
  <T, P>(
    {
      getValidationClassName,
      onInputChange,
      control,
      formState,
      value,
      label,
      required = false,
      error,
      onSubmitEditing,
    }: TextInputControlProps<T, P>,
    ref: React.Ref<TextInput>,
  ): React.ReactElement => {
    const classNames = useMemo(() => {
      if (control?.classNames) {
        return [...getValidationClassName().classes].concat(control.classNames);
      } else {
        return [...getValidationClassName().classes, "input", "inputLarge"];
      }
    }, [getValidationClassName, control.classNames]);

    return (
      <FormInput
        ref={ref}
        isOptional={!required}
        label={label}
        input={{
          classNames,
          onChangeText: onInputChange,
          onSubmitEditing,
          placeholder: control.placeholder,
          value: value && String(value),
          ...(control.props || {}),
        }}
        disabled={!!control.disabledIf && control.disabledIf(formState)}
        state={getValidationClassName().state}
        message={error || ""}
      />
    );
  },
);
